// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 767px) {\n.basic-filters__lang-select .sk-select {\n    width: 100%;\n    margin-left: 0;\n    border: 1px solid #a7acbe;\n}\n.basic-filters__lang-select .sk-select__value,\n  .basic-filters__lang-select .sk-select__typing-input {\n    padding: 0 10px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
